import { keyframes } from "@chakra-ui/react";

export default keyframes`
  0% {
    opacity: 1;
  }
  41% {
    opacity :1;
  }
  50% {
    opacity: 0;
  }
  91% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;
